const DEFAULT_MULTIPLIER = 1;
const MIN_MULTIPLIER = 0.5;
const MAX_MULTIPLIER = 2;

export function applyDynamicFontSize() {
  const urlParams = new URLSearchParams(window.location.search);
  const multiplierParam = urlParams.get('fs');

  if (!multiplierParam) {
    return;
  }

  let multiplier = parseFloat(multiplierParam);

  if (isNaN(multiplier)) {
    // eslint-disable-next-line
    console.warn(
      `Invalid font multiplier value: "${multiplierParam}". Using default: ${DEFAULT_MULTIPLIER}`
    );
    multiplier = DEFAULT_MULTIPLIER;
  } else {
    multiplier = Math.max(MIN_MULTIPLIER, Math.min(multiplier, MAX_MULTIPLIER));
  }

  document.documentElement.style.zoom = multiplier;
}



// WEBPACK FOOTER //
// /tmp/build_c2a4b37a/src/fontsize.js